module.exports = __webpack_public_path__ + "img/zl.ddeeb95e.png";